import { Component, Input, OnInit } from '@angular/core';
import * as highcharts from "highcharts";

@Component({
  selector: 'app-basiccolumn-chart',
  templateUrl: './basiccolumn-chart.component.html',
  styleUrls: ['./basiccolumn-chart.component.scss']
})
export class BasiccolumnChartComponent implements OnInit {
  @Input() data: any;
  highcharts = highcharts;
  columnChartOptions = {};
  chartOptions = {}
  constructor() { }

  ngOnInit() {
    this.plotChart();
  }

  
  plotChart() {
    
    return this.chartOptions = {
      chart: {
        type: "column",
        scrollablePlotArea: {
          minWidth: 100
        }
      },
      title: {
        text: ""
      },
      categories: ["2021","2022","2023","2024","2025","2026","2027","2028"],
      xAxis: {
        title:{
          enabled:false
        },
        scrollbar: {
          enabled: false
        },
      },
      yAxis:{
        title:{
          enabled:false
        }
      },
      colors: [
        '#2A93FB',
        '#BFE4FF',
        ],    
      column: {
        colorByPoint: true
    },
    legend: {
      verticalAlign: 'top',
      layout: 'horizontal',
      margin: 25,
      itemMarginTop: 0,
      symbolRadius: 0,
      symbolHeight: 10,
      symbolWidth: 10
  },
      series: [
        
        {
          type: "column",
          name: "PT",
          data: [200, 120, 200, 160, 200]
        },
        {
          name: "CED",
          type: "column",
          data: [160, 80, 120, 100, 160]
        }
      ]
    };
  
  }
 
}

